"use client";

import { cn } from "@/lib/utils";
import { useStorageQuery } from "../../hooks/storageQueryProvider";

export default function StoragePadding({
    classNameWhenSelectedItemsMenuIsShown,
    classNameWhenSelectedItemsMenuIsHidden,
}: {
    classNameWhenSelectedItemsMenuIsShown: string;
    classNameWhenSelectedItemsMenuIsHidden: string;
}) {
    const { showSelectedItemsMenu } = useStorageQuery();

    return (
        <div
            className={cn(
                showSelectedItemsMenu
                    ? classNameWhenSelectedItemsMenuIsShown
                    : classNameWhenSelectedItemsMenuIsHidden
            )}
        />
    );
}
